import script from "./confirmationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmationDialog.vue?vue&type=script&setup=true&lang=js"

import "./confirmationDialog.vue?vue&type=style&index=0&id=e4d4fb14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4d4fb14"]])

export default __exports__